import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BuildingApiService } from './building-api.service';
import { map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { xml2js } from 'xml-js';
import { environment } from '../../../environments/environment';
import { IFileUpload } from '../../types/api-response/fileUpload';
import { FileDocument, IFileDocument } from '../../types/file-document';

@Injectable()
export class FileUploadApiService {

    constructor(
        private http: HttpClient,
        private buildingApi: BuildingApiService,
    ) {
    }

    /**
     * Returns uploaded fileURL
     * for direct file upload to amazon S3 services
     *
     * @param file
     * @param folderName
     */
    public s3directUpload(file: File, folderName = 'uploads'): Observable<FileDocument> {
        const formData: FormData = new FormData();

        return this.buildingApi.getS3token(folderName).pipe(
            switchMap(s3credentials => {
                // S3 direct upload input data
                Object.getOwnPropertyNames(s3credentials.formInputs)
                    .forEach(keyName => formData.append(keyName, s3credentials.formInputs[keyName]));

                // add file as last item (!order is important!)
                formData.append('file', file, file.name);

                return this.http.post(s3credentials.formUrl, formData, {responseType: 'text'}).pipe(
                    map(response => { // Returns XML string
                        const data: any = xml2js(response, {compact: true, ignoreAttributes: true, ignoreDeclaration: true});

                        return new FileDocument(file, data.PostResponse.Location._text);
                    })
                );
            })
        );
    }

    /**
     * Upload file
     * using upload service
     *
     * @param file
     */
    public fileUpload(file: File): Observable<IFileDocument> {
        const formData: FormData = new FormData();
        formData.append('fileUpload', file, file.name);

        return this.http.post(`${environment.domainBD}/_uploader/attachments/upload`, formData).pipe(
            map((result: IFileUpload) => new FileDocument(file, result.path))
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/api/file-upload-api.service.ts